import { RefundAnalysisTemplate } from "../../Templates/RefundAnalysisTemplate";

export const RefundAnalysis = () => {
  return <RefundAnalysisTemplate />;
};
